export const getQuickActions = (currentUserType, navigate) => {
  return [
    {
      title: 'Add Product',
      description: 'Add a new product to your shop',
      bgColor: 'bg-secondary-600',
      textColor: 'text-white',
      action: () => navigate(`/${currentUserType}/add-product`),
    },
    {
      title: 'View My Products',
      description: 'Manage your existing products',
      bgColor: 'bg-background',
      textColor: 'text-gray-800',
      border: 'border border-gray-200',
      action: () => navigate(`/my-products`),
    },
    {
      title: 'View My Shop',
      description: 'See how your shop looks to customers',
      bgColor: 'bg-background',
      textColor: 'text-gray-800',
      border: 'border border-gray-200',
      action: () => navigate(`/my-shop`),
    },
  ]
}

export const MAX_IMAGES_PER_PRODUCT = 10
export const MAX_IMAGE_SIZE_BYTES = 2 * 1024 * 1024
